<template>
  <div class="rm-screen">
    <div v-if="busy" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!sections.length" class="rm-empty">
      <v-icon v-if="!searchText" size="40" color="#8a817a">mdi-store-outline</v-icon>
      {{ emptyTitle }}
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div v-for="(stat, index) in kpis" :key="stat.key" class="rm-stat" :class="{ 'rm-stat--inverse': index === 0 }">
          <span class="rm-stat__label">{{ stat.label }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <section v-for="section in sections" :key="section.key" class="rm-card rm-mcard">
        <button
          type="button"
          class="rm-mcard__head"
          :aria-expanded="String(isOpen(section.key))"
          @click="toggleCard(section.key)"
        >
          <span class="rm-mcard__title">
            <span class="rm-mcard__name">{{ section.name }}</span>
            <span class="rm-muted">{{ section.summary }}</span>
          </span>
          <span class="rm-mcard__value rm-num">{{ section.total }}</span>
          <v-icon size="18" color="#8a817a" class="rm-mcard__chevron" :class="{ 'is-open': isOpen(section.key) }">
            mdi-chevron-down
          </v-icon>
        </button>

        <ul v-if="isOpen(section.key)" class="rm-list rm-mcard__list">
          <li v-for="row in section.rows" :key="row.key" class="rm-mrow">
            <div class="rm-mrow__main">
              <span class="rm-mrow__text">
                <span class="rm-mrow__name">{{ row.name }}</span>
                <span v-if="row.type" class="rm-muted">{{ row.type }}</span>
              </span>
              <span class="rm-mrow__value rm-num">{{ row.total }}</span>
            </div>
            <div v-if="rowShifts(row).length" class="rm-mrow__shifts">
              <span v-for="shift in rowShifts(row)" :key="shift.id" class="rm-mrow__shift rm-num">
                <report-shift-tag :shift="shift.id"></report-shift-tag>
                {{ shift.text }}
              </span>
            </div>
          </li>
        </ul>
      </section>
    </template>
  </div>
</template>

<script>
import CompanyDesktopMultiRestaurantMeals from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiRestaurantMeals.vue";
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";
import "@/components/report/mobile/screens/reportMobileMealCards.scss";
import hasMultiMobile from "../../hasMultiMobile";

/**
 * Mobilni "Restorani obroci" firme "više restorana": po restoranu kartica sa obrocima i brojem po smeni (kupci i
 * restoran). Kartice se sklapaju; u pretrazi su sve otvorene da se nalazi vide. Računa kao ekran za računar.
 */
export default {
  name: "CompanyMobileMultiRestaurantMeals",
  extends: CompanyDesktopMultiRestaurantMeals,
  mixins: [hasMultiMobile],
  components: { ReportShiftTag },
  data: () => ({
    closedCards: {},
  }),
  methods: {
    isOpen(key) {
      return Boolean(this.searchText) || !this.closedCards[key];
    },
    toggleCard(key) {
      this.closedCards = { ...this.closedCards, [key]: !this.closedCards[key] };
    },
    /** Smene u kojima obrok ima količinu (samo prikazane). */
    rowShifts(row) {
      return this.visibleShifts
        .filter((shift) => row[shift.key] > 0)
        .map((shift) => ({ id: shift.id, text: row.text[shift.key] }));
    },
  },
};
</script>
